import { Theme } from '@mui/material/styles'

// ==============================|| OVERRIDES - ALERT TITLE ||============================== //

export default function Form(theme: Theme) {
  return {
    MuiFormLabel: {
      defaultProps: {},
      styleOverrides: {
        root: {
          fontSize: '14px',
          lineHeight: '20px',
          fontWeight: 500,
          color: theme.palette.primary.main,
        },
      },
    },
  }
}
